import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { NotificationService } from "../services/notifications.service"

export const setDeviceNotifToken = createAsyncThunk(
  "setDeviceNotifToken",
  async ({ token, authToken }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await NotificationService.setNotifToken(token, authToken)
      return fulfillWithValue(response)
    } catch (err) {
      return rejectWithValue({
        status: err.response.status,
        message: err.message,
      })
    }
  }
)

export const deleteDeviceNotifToken = createAsyncThunk(
  "deleteDeviceNotifToken",
  async ({ token, authToken }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await NotificationService.removeNotifToken(
        token,
        authToken
      )
      return fulfillWithValue(response)
    } catch (err) {
      return rejectWithValue({
        status: err.response.status,
        message: err.message,
      })
    }
  }
)

const notificationsDetailsSlice = createSlice({
  name: "notificationsDetails",
  initialState: {
    isLoading: false,
    successMessage: "",
    errorMessage: "",
    errorCode: null,
    notificationToken: null,
  },
  reducers: {
    clearMessages: (state, action) => {
      state.errorMessage = ""
      state.successMessage = ""
      state.errorCode = null
    },
    setStateNotificationToken: (state, action) => {
      state.notificationToken = action.payload.notificationToken;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(setDeviceNotifToken.pending, (state, action) => {
        state.isLoading = true
        state.errorMessage = ""
        state.successMessage = ""
      })
      .addCase(setDeviceNotifToken.fulfilled, (state, action) => {
        state.isLoading = false
        state.successMessage = "toasts.push-notif-successfully-set"
      })
      .addCase(setDeviceNotifToken.rejected, (state, action) => {
        state.isLoading = false
        state.errorCode = action.payload.status
        state.errorMessage = action.payload.message
      })
      .addCase(deleteDeviceNotifToken.pending, (state, action) => {
        state.isLoading = true
        state.errorMessage = ""
        state.successMessage = ""
      })
      .addCase(deleteDeviceNotifToken.fulfilled, (state, action) => {
        state.isLoading = false
        state.successMessage = "toasts.push-notif-successfully-removed"
      })
      .addCase(deleteDeviceNotifToken.rejected, (state, action) => {
        state.isLoading = false
        state.errorCode = action.payload.status
        state.errorMessage = action.payload.message
      })
  },
})
export const { clearMessages, setStateNotificationToken } = notificationsDetailsSlice.actions

export default notificationsDetailsSlice.reducer
